// extracted by mini-css-extract-plugin
export default {"wrapper":"Player_wrapper__lsgUM","container":"Player_container__SZ7IP","playerControl":"Player_playerControl__9z8GY","options":"Player_options__+RnWr"};